<template>
  <v-container class="fill-height">
    <v-row v-if="entranceContent">
      <v-col md="10" offset-md="1">
        <v-alert type="success" v-if="success">
          Entrance successfully updated
        </v-alert>
        <v-alert type="error" v-if="error">
          Something went wrong. Please check the developer console!
        </v-alert>
        <v-tabs v-model="languageTab" background-color="transparent">
          <v-tab v-for="language in languages" :key="language.code" :href="'#' + language.code">
            {{ language.name }}
          </v-tab>
        </v-tabs>
        <v-form @submit.prevent="handleSubmit" id="building-create-form" class="building-create-form" ref="form" v-model="isValid">
          <div v-for="language in languages" :key="language.code" v-show="language.code === languageTab">
            <v-row>
              <v-col md="6">
                <v-autocomplete v-model="selectedBuilding" class="building-autocomplete" prepend-icon="mdi-office-building" :items="autocompleteValues" label="Изберете сграда" :rules="[rules.required]" required />
              </v-col>
              <v-col md="6">
                <v-text-field name="title" prepend-icon="mdi-pencil" label="Заглавие" v-model="entranceContent[language.code].title" :rules="[rules.required]" required></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="12">
                <v-textarea prepend-icon="mdi-map-marker-path" v-model="coordinates" name="coordinates" label="Координати"></v-textarea>
              </v-col>
            </v-row>
            <v-expansion-panels v-model="seoPanel" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>SEO</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col md="6">
                      <v-text-field name="slug" prepend-icon="mdi-pencil" label="Слъг" v-model="entranceContent[language.code].slug" :rules="[rules.required]" required></v-text-field>
                    </v-col>
                    <v-col md="6">
                      <v-text-field name="seo_title" prepend-icon="mdi-pencil" label="Заглавие" v-model="entranceContent[language.code].seoTitle"></v-text-field>
                    </v-col>
                    <v-col md="12">
                      <v-text-field name="seo_description" prepend-icon="mdi-pencil" label="Описание" v-model="entranceContent[language.code].seoDescription"></v-text-field>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-row>
              <v-col md="3">
                <v-switch value input-value="true" label="Активен в сайта" color="indigo" v-model="isActive"></v-switch>
              </v-col>
            </v-row>
          </div>
        </v-form>
        <v-btn color="success" type="submit" form="building-create-form">Запиши</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { updateEntrance } from '@/repositories/entrance.repository'
export default {
  data () {
    return {
      isValid: false,
      title: null,
      coordinates: null,
      slug: null,
      seoTitle: null,
      seoDescription: null,
      isActive: true,
      seoPanel: [0],
      selectedBuilding: null,
      success: false,
      error: false,
      entranceContent: null,
      languageTab: null,
      rules: {
        required: value => !!value || 'Това поле е задължително!'
      }
    }
  },
  created () {
    this.$store.dispatch('fetchLanguages')
      .then(() => {
        this.entranceContent = {};
        for (const language of this.languages) {
          this.entranceContent[language.code] = {
            title: null,
            seoTitle: null,
            seoDescription: null,
            slug: null
          };
        }

        this.$store.dispatch('fetchEntrance', this.$route.params.id)
      })
    this.$store.dispatch('fetchBuildings')
  },
  computed: {
    languages () {
      return this.$store.state.language.languages
    },
    buildings () {
      return this.$store.state.building.buildings
    },
    building () {
      return this.$store.getters.getBuilding(+this.$route.params.building)
    },
    entrance () {
      return this.$store.state.entrance.entrance
    },
    autocompleteValues () {
      const buildings = [...this.buildings]
      return buildings.map(building => ({
        text: building.translations ? building.translations.title : '',
        value: building.id
      }))
    }
  },
  watch: {
    entrance (entrance) {
      if (entrance) {
          this.setEntranceValues()
      }
    }
  },
  methods: {
    setEntranceValues () {
      this.selectedBuilding = this.entrance.buildingId
      this.coordinates = this.entrance.coordinates
      this.isActive = this.entrance.active

      const entranceTranslations = this.entranceContent[this.languageTab]
      this.entrance.translations.seoDescription && (entranceTranslations.seoDescription = this.entrance.translations.seoDescription)
      this.entrance.translations.seoTitle && (entranceTranslations.seoTitle = this.entrance.translations.seoTitle)
      this.entrance.translations.slug && (entranceTranslations.slug = this.entrance.translations.slug)
      this.entrance.translations.title && (entranceTranslations.title = this.entrance.translations.title)
    },
    handleSubmit () {
      this.$refs.form.validate()
      if (!this.isValid) {
        return
      }

      this.createEntrance()
    },
    createEntrance () {
      const entrance = {
        coordinates: this.coordinates,
        active: this.isActive,
        buildingId: this.selectedBuilding ? this.selectedBuilding : this.$route.params.building,
        ...this.entranceContent
      }

      try {
        updateEntrance(this.$route.params.id, entrance)
          .then(response => {
            const { success } = response.data
            this.success = success
            this.error = !this.success

            this.reset()
          }).catch(error => {
            console.log(error)
            this.error = true
            this.success = false
          })
      } catch (e) {
        console.log(e)
        this.error = true
        this.success = false
      }
    },
    reset () {
      this.$refs.form.reset()
    }
  }
}
</script>

<style lang="scss">
.change-building-link {
  font-size: 0.875rem;
  text-decoration: none;
}
.building-autocomplete {
  .v-input__append-outer {
    pointer-events: initial;
    position: absolute;
    right: 30px;
    z-index: 999;
    cursor: pointer;
  }
}
</style>